import React from 'react';
import { Reveal } from './Reveal';
type Testimonial = {
  initials: string;
  quote: string;
  name: string;
  role: string;
};
const testimonials: Testimonial[] = [{
  initials: 'SM',
  quote: 'I was terrified to take my first client. This system gave me the confidence I needed. I followed the protocols exactly. My client had a breakthrough in the first session. Now I’m booked out 3 months and charging 4X what I used to charge. This system fundamentally changed my entire practice.',
  name: 'Sarah M.',
  role: 'Los Angeles, USA · Therapeutic Tarot Reader'
}, {
  initials: 'JK',
  quote: 'Volume 5 alone saved me hours every single week. Having everything organized in one place means I’m never searching mid-session for answers. My clients feel the difference immediately. The transformation is real. They’re booking their next sessions before they even leave my office.',
  name: 'James K.',
  role: 'London, UK · Energy Healer & Coach'
}, {
  initials: 'DR',
  quote: 'The ethics bonus answered questions I didn’t even know I had. Now I practice with complete confidence that I’m handling everything correctly. The legal clarity, scope of practice definition, and informed consent templates alone were worth 10X the price. I finally feel like a legitimate professional.',
  name: 'Diana R.',
  role: 'Toronto, Canada · Spiritual Coach & Practitioner'
}];
export function TestimonialStrip() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-224" data-mp="2999jjsns0bhl">
      <div className="mx-auto max-w-6xl" data-id="element-225" data-mp="255a7pndfy0uk">
        <Reveal className="text-center" data-id="element-226" data-mp="2j5ky6pau9df7">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-227" data-mp="2j4jl6fa9iguu">
            ⭐ What Practitioners Are <span className="text-sage" data-id="element-228" data-mp="2e7jk6is9s4al">Saying</span>
          </h2>
          <p className="mt-4 text-slate" data-id="element-229" data-mp="orbosj6n1x73">
            People who finally have the professional system their practice deserved.
          </p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-230" data-mp="jubic75vmsfg">
          {testimonials.map((item, index) => <Reveal key={item.initials} delay={index * 0.05} data-id="element-231" data-mp="2jwt75s8hwac8" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-navy/10 bg-surface p-8 shadow-premium" data-id="element-232" data-mp="2ouunw6ig7xkj">
                <div className="text-amber" aria-label="5 out of 5 stars" data-id="element-233" data-mp="2stv73q4u9282">
                  ★★★★★
                </div>
                <blockquote className="mt-5 flex-1 text-[15px] leading-7 text-slate" data-id="element-234" data-mp="2xsevdx6wmq3l">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-3" data-id="element-235" data-mp="37rvw007audsp">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sage/15 text-sm font-bold text-sage" data-id="element-236" data-mp="3cje190gcv0jh">
                    {item.initials}
                  </span>
                  <span data-id="element-237" data-mp="3lk3rlomujypt">
                    <span className="block font-bold text-navy" data-id="element-238" data-mp="3lkvapzz9c3z7">{item.name}</span>
                    <span className="mt-0.5 block text-xs text-slate" data-id="element-239" data-mp="3qix53h24vppz">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}